export const MENU = {
  admin: [
    [
      {
        key: "menu_lecture",
        list: [{ key: "menu_lecture_list", label: "강의", to: "/lecture" }],
      },
      {
        key: "menu_users",
        list: [{ key: "menu_users_list", label: "회원", to: "/users" }],
      },
      {
        key: "menu_quiz",
        list: [{ key: "menu_quiz_list", label: "퀴즈", to: "/quiz" }],
      },
      {
        key: "menu_survey",
        list: [{ key: "menu_survey_list", label: "설문", to: "/survey" }],
      },
    ],
    null,
  ],
  teacher: [
    [
      {
        key: "menu_lecture",
        list: [{ key: "menu_lecture_list", label: "강의", to: "/lecture" }],
      },
      {
        key: "menu_users",
        list: [{ key: "menu_users_list", label: "회원", to: "/users" }],
      },
      {
        key: "menu_quiz",
        list: [{ key: "menu_quiz_list", label: "퀴즈", to: "/quiz" }],
      },
      {
        key: "menu_survey",
        list: [{ key: "menu_survey_list", label: "설문", to: "/survey" }],
      },
    ],
    null,
  ],
  student: [
    [
      {
        key: "menu_dashboard",
        list: [
          {
            key: "menu_dashboard",
            label: "대시보드",
            to: "/student",
          },
        ],
      },
      {
        key: "menu_lecture",
        list: [
          { key: "menu_lecture_list", label: "강의", to: "/student/lecture" },
        ],
      },
    ],
    null,
    // [
    //   { key: "dropdown_my_profile", label: "내 정보", to: "/student/my" },
    //   { key: "dropdown_my_lectures", label: "내 강의", to: "/student/my" },
    //   { key: "dropdown_signout", label: "로그아웃", to: "/signout" },
    // ],
  ],
  none: [null, null],
};
